import { RootLineageNode } from "./RootLineageNode";
import { useState } from "react";
import { LineageNode } from "@/features/FileManagement/fileManagement.types";
import clsx from "clsx";

export function FileLineageTree({ nodes }: { nodes: LineageNode[] }) {
    const [openIndex, setOpenIndex] = useState<[number, number]>([0, -1]);

    return (
        <ul className={clsx("flex flex-col gap-6")}>
            {nodes.map((node, index) => (
                <RootLineageNode
                    node={node}
                    key={node.id}
                    isLast={index === nodes.length - 1}
                    isOpen={openIndex[0] === 0 && openIndex[1] === index}
                    setIsOpen={(isOpen) => {
                        setOpenIndex([0, isOpen ? index : -1]);
                    }}
                />
            ))}
        </ul>
    );
}

export const nodes: LineageNode[] = [
    {
        id: "1",
        emphasizedText: "File created",
        text: "from Codat pull",
        status: "completed",
        date: "10/10/2025",
        link: {
            label: "View file in labeling",
            href: "/beta/companies/123/labeling/files/123",
        },
    },
    {
        id: "2",
        emphasizedText: "File cleaned",
        text: "",
        status: "completed",
        date: "10/10/2025",
        link: {
            label: "View file in labeling",
            href: "/beta/companies/123/labeling/files/123",
        },
        nodes: [
            {
                id: "3",
                emphasizedText: "Michael Foster",
                text: "labeled this file",
                status: "completed",
                date: "10/10/2025",
                link: {
                    label: "View file in labeling",
                    href: "/beta/companies/123/labeling/files/123",
                },
                nodes: [
                    {
                        id: "5",
                        emphasizedText: "Data ingested",
                        text: "for metrics",
                        status: "completed",
                        date: "10/12/2025",
                    },
                ],
            },
            {
                id: "10",
                emphasizedText: "Blair Silververg",
                text: "labeled this file",
                status: "completed",
                date: "10/10/2025",
                link: {
                    label: "View file in labeling",
                    href: "/beta/companies/123/labeling/files/123",
                },
                nodes: [
                    {
                        id: "88",
                        text: "Data not yet ingested for metrics",
                        status: "in-progress",
                    },
                ],
            },
        ],
    },
    {
        id: "5",
        emphasizedText: "File cleaned",
        text: "",
        status: "completed",
        date: "10/10/2025",
        nodes: [
            {
                id: "6",
                emphasizedText: "Michael Foster",
                text: "labeled this file",
                status: "completed",
                nodes: [
                    {
                        id: "7",
                        text: "Data not yet ingested for metrics",
                        status: "in-progress",
                    },
                ],
            },
        ],
    },
];
